import {
    Component, EventEmitter, inject,
    Input,
    Output,
    TemplateRef,
    ViewEncapsulation,
} from '@angular/core';
import { Store } from '@ngrx/store';

import { ProductFilterItem, UpdateFilterObj } from '../../../menu-categories/models/menu-categories.model';

import { MenuCategory } from '@shared/header/models/category.model';
import { GoToCategory } from '@shared/navigation';

type FilterMapping = Record<string, ProductFilterItem[] | boolean>;

@Component({
    selector: 'category-sub-categories-default',
    templateUrl: './category-sub-categories-default.component.html',
    // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
    encapsulation: ViewEncapsulation.None,
})
export class CategorySubCategoriesDefaultComponent {
    private readonly store: Store = inject(Store);

    @Input() public selectGridView: TemplateRef<any>;

    @Input() public siblingCategories: MenuCategory[];

    @Input() public currentCategoryFromABTest: MenuCategory;

    @Input() public showDebugCategoryIds: boolean;

    @Input() public filtersArray: ProductFilterItem[];

    @Input() public isNormalBehavior: boolean;

    @Input() public filterTypeUsed: string;

    @Input() public lastSectionTranslated: string;

    @Input() public direction: string;

    @Output() public readonly updateFilterEmitter: EventEmitter<UpdateFilterObj> = new EventEmitter();

    public updateFilter(filterType: string): void {
        const filterMapping: FilterMapping = {};

        // biome-ignore lint/complexity/noForEach: <explanation>
        this.filtersArray.forEach(el => {
            filterMapping[el.name] = el.name === filterType;
        });

        const updateFilterObj: UpdateFilterObj = {
            filterMapping: filterMapping,
            filterTypeUsed: this.filterTypeUsed,
        };

        this.updateFilterEmitter.emit(updateFilterObj);
    }

    public goToCategory(category: MenuCategory): void {
        const id = category.redirectToCategoryId ? category.redirectToCategoryId : category.id;
        this.store.dispatch(GoToCategory({ categoryId: id }));
    }
}
